import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import { constants } from '../../modules';

const MembershipBenefits = dynamic(() => import('./MembershipBenefits').then(mod => mod.MembershipBenefits));
const MembershipBenefitsV2 = dynamic(() =>
  import('./MemberBenefitsV2/MembershipBenefitsV2').then(mod => mod.MembershipBenefitsV2)
);

export const MembershipBenefitsConfig = {
  emptyLabel: 'MembershipBenefits',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/membershipbenefits`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MembershipBenefitsEditable = (props: any) => {
  return (
    <EditableComponent config={MembershipBenefitsConfig} {...props}>
      {props?.model?.variation === constants.VARIATION_2 ? (
        <MembershipBenefitsV2 {...props} />
      ) : (
        <MembershipBenefits {...props} />
      )}
    </EditableComponent>
  );
};
